module.exports = __webpack_public_path__ + "img/hgl-brand-logo.61f3098a.png";